import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=5a96f531&scoped=true&"
import script from "./AddEvent.vue?vue&type=script&lang=ts&"
export * from "./AddEvent.vue?vue&type=script&lang=ts&"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=5a96f531&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96f531",
  null
  
)

export default component.exports